import { Component, ContentChild, ContentChildren, Directive, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ButtonList } from '../actions-buttons/actions-buttons.component';
import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';



@Component({
    selector: 'side-panel-step',
    styleUrl: './side-panel-stepper.component.scss',
    template: '<ng-template><ng-content></ng-content></ng-template>', // Step 3
    providers: [{ provide: CdkStep, useExisting: SidePanelStepComponent }],
    standalone: false
})
export class SidePanelStepComponent extends CdkStep { // Step 1
  @Input() title?: string;
  @Input() info?: string;
}


@Component({
    selector: 'side-panel-stepper',
    templateUrl: './side-panel-stepper.component.html',
    styleUrl: './side-panel-stepper.component.scss',
    providers: [{ provide: CdkStepper, useExisting: SidePanelStepperComponent }],
    animations: [
        trigger('slideInOut', [
            state('in', style({ transform: 'translateY(0%)' })),
            state('out', style({ transform: 'translateY(0%)' })),
            transition('out=>*', [group([
                    animate('1000ms', style({ transform: 'translateY(0%)' }))
                ])])
        ]),
        trigger('tabMovement', [
            state('up', style({ transform: 'translateY(0%)' })),
            state('down', style({ transform: 'translateY(0%)' })),
            transition('*<=>*', [style({ transform: 'translateY({{offset}}%)' }), animate('0.5s')])
        ])
    ],
    standalone: false
})


export class SidePanelStepperComponent extends CdkStepper implements OnInit {

  animationState = 'in';

  ngOnInit(): void {    
  }

  selectedName  = 'none';
  typeSelection='down';
  multiplyer = 0;
  multiplyerBody = 100;
  
  @Input()sizeLeft:number=50;
  @Input()sizeRight:number=50;

  @Output() onChange:EventEmitter<any> = new EventEmitter();
  
  dragEnd(evento){
      this.onChange.emit(evento);
  }

  selectTabName(selectedid){

    const old = this.selectedIndex;
    this.selectedIndex = selectedid;
    
    if ( old == this.selectedIndex ){
      this.typeSelection = 'none';
    }

    if ( old < this.selectedIndex ){
      this.typeSelection = 'down'+this.selectedIndex;
      this.multiplyer = (old-this.selectedIndex)*100;
      this.multiplyerBody= 100;
    }else{
      this.typeSelection = 'up'+this.selectedIndex;
      this.multiplyer = (old - this.selectedIndex)*100;
      this.multiplyerBody= -100;
    }
  }
}
